module.exports = __webpack_public_path__ + "img/starfruit-350x184.48245a8f.jpg";